<template>
  <label
    class="fp-input-wrapper"
    :class="{
      '-nolabel': !label
    }"
  >
    <span
      class="fp-input-label"
    >{{ label }}</span>
    <input
      v-bind="$attrs"
      v-model="model"
      class="fp-input"
      :class="{
        '-small': small,
        '-ghost': ghost,
        '-error': error
      }"
    >

    <Transition name="error">
      <span
        v-if="error"
        class="fp-input__error"
      >{{ error }}</span>
    </Transition>
  </label>
</template>

<script setup lang="ts">
defineProps<{
  small?: boolean,
  ghost?: boolean,
  error?: string,
  label?: string
}>();

const model = defineModel<string>();
</script>

<style scoped lang="scss">
.fp-input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: start;
  width: 100%;

  &.-nolabel {
    display: contents;
  }
}

.fp-input-label {
  font-weight: bold;

  &:empty {
    display: none;
  }
}

.fp-input {
  display: block;
  box-sizing: border-box;
  width: inherit;
  font: inherit;
  padding: 16px;
  border-radius: 12px;
  border: 2px solid var(--clr-text-primary);
  color: var(--clr-text-primary);
  @include filled-shadow(4);

  &:focus {
    outline: none;
  }

  &.-small {
    padding: 8px;
  }

  &.-ghost {
    border-color: var(--clr-gray);
    box-shadow: none;
  }

  &:disabled {
    color: gray;
    cursor: not-allowed;
  }

  &.-error {
    border-color: var(--clr-red);
  }
}

.fp-input__error {
  color: var(--clr-red);
  font-size: 12px;
  text-align: left;
}

.error-enter-active,
.error-leave-active {
  transition: max-height .2s, opacity .2s;
}

.error-enter-from,
.error-leave-to {
  opacity: 0;
  max-height: 0;
}

.error-enter-to,
.error-leave-from {
  max-height: 32px;
}
</style>
